// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"input-number_inputNumber__2DzMy"};